import { Module } from "vuex";

const componentModule: Module<any, any> = {
    state() {
        return {
            lastSelection: { index: 0, length: 0 },
        };
    },
    getters: {
        lastSelection: (state) => state.lastSelection,
    },
    mutations: {
        SET_LAST_SELECTION: (state, data) => {
            state.lastSelection = data;
        },
    },
};

export default componentModule;
